import { Component, computed, input } from '@angular/core';
import { IBrand } from '../shop-by-brand/_prismic/brands-reel';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-brand-card',
    templateUrl: './brand-card.component.html',
    styleUrls: ['./brand-card.component.scss'],
    imports: [RouterLink]
})
export class BrandCardComponent {
  readonly brand = input.required<IBrand>();

  readonly brandUrl = computed(() => `/brands/${this.brand().name.toLowerCase().replace(/\s+/g, '-')}`);

}
